<template>
  <div>
    <v-dialog scrollable v-model="value" max-width="800" persistent>
      <v-card>
        <v-card-text>
          <v-layout>
            <v-flex class="pa-3"> </v-flex>

            <v-flex class="text-xs-right">
              <v-btn small flat fab @click="close" :loading="loading">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-stepper v-model="step" class="elevation-0">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">ตั้งค่าผู้ส่ง</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2">เลือกขนส่ง</v-stepper-step>
            </v-stepper-header>
          </v-stepper>

          <template v-if="step == 1">
            <h2>เลือกที่อยู่ผู้ส่ง</h2>
            <shipping-address></shipping-address>

            <h2>ช่องทางการจัดส่งสินค้า</h2>
            <div class="text-xs-left">
              <v-radio-group v-model="useCustomCourier" row>
                <v-radio
                  label="ขนส่งตามที่ลูกค้าเลือก"
                  value="bycustomer"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="เปลี่ยนขนส่งสำหรับทุกออเดอร์"
                  value="bymerchant"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </div>

            <div class=" mt-2" v-if="useCustomCourier == 'bymerchant'">
              <label class="primary--text">{{ $t('Shipping Method') }}</label>
              <v-select
                v-model="customCourier"
                :items="couriers"
                :data-vv-as="'courier code'"
                name="couriercode"
                :placeholder="$t('Shipping Method')"
                outline
                :hide-details="errors.has('couriercode')"
                :error-messages="errors.first('couriercode')"
                v-validate="'required'"
              ></v-select>
            </div>

            <div class="text-xs-center">
              <v-btn color="grey" outline @click="close" :loading="loading">{{
                $t('cancel')
              }}</v-btn>
              <v-btn
                color="primary"
                depressed
                @click="nextStep(2)"
                :loading="loading"
                :disabled="!addresses || addresses.length == 0"
                >{{ $t('Next') }}</v-btn
              >
            </div>
          </template>
          <template v-else-if="step == 2">
            <h2>กรุณาตรวจสอบขนส่งอีกครั้งก่อนยืนยันการทำรายการ ({{ totalOrder }} รายการ)</h2>
            <div style="max-height:600px; overflow: auto" class="my-2">
              <template v-for="(orders, oindex) in tmporders">
                <template v-for="(order, index) in orders">
                  <v-layout wrap :key="'shippop_' + oindex + '_' + order.orderid">
                    <v-flex xs12 sm3 class="py-2">
                      <v-chip small color="blue" class="white--text" disabled
                        >Order No.: {{ order.orderid }}</v-chip
                      >
                    </v-flex>
                    <v-flex xs12 sm5 class="pa-2">
                      {{ order.orderzwiz.nameaddress }}
                    </v-flex>
                    <v-flex xs12 sm4>
                      <select-shippop-courier
                        v-model="tmporders[oindex][index].courier_code"
                        :shippingtype="order.orderzwiz.shippingtype"
                        :couriers="order.shippopresult"
                        :hide-details="!errors.has(`courier_code_${index}`)"
                        :error="errors.has(`courier_code_${index}`) ? true : false"
                        :error-messages="
                          errors.has(`courier_code_${index}`)
                            ? errors.first(`courier_code_${index}`)
                            : ''
                        "
                      ></select-shippop-courier>
                      <input
                        type="hidden"
                        :data-vv-as="'courier code'"
                        :name="`courier_code_${index}`"
                        v-model="tmporders[oindex][index].courier_code"
                        v-validate="'required'"
                      />
                    </v-flex>
                    <v-flex xs12 v-if="tmporders[oindex][index].courier_code == 'SCGX'">
                      <div class="primary--text">กรุณากรอกรายละเอียดพัสดุ</div>
                      <v-layout :key="`parcel_size_${index}`">
                        <v-flex class="form-control pl-1">
                          <input
                            v-validate="'required'"
                            :name="`parcel.width`"
                            type="text"
                            v-model="tmporders[oindex][index].parcel.width"
                            :placeholder="$t('width')"
                            :data-vv-as="$t('width')"
                          />
                          <div class="error--text caption" v-if="errors.has(`parcel.width`)">
                            {{ errors.first(`parcel.width`) }}
                          </div>
                        </v-flex>

                        <v-flex class="form-control pl-1">
                          <input
                            v-validate="'required'"
                            :name="`parcel.length`"
                            type="text"
                            v-model="tmporders[oindex][index].parcel['length']"
                            :placeholder="$t('length')"
                            :data-vv-as="$t('length')"
                          />
                          <div class="error--text caption" v-if="errors.has(`parcel.length`)">
                            {{ errors.first(`parcel.length`) }}
                          </div>
                        </v-flex>
                        <v-flex class="form-control pl-1">
                          <input
                            v-validate="'required'"
                            :name="`parcel.height`"
                            type="text"
                            v-model="tmporders[oindex][index].parcel.height"
                            :placeholder="$t('height')"
                            :data-vv-as="$t('height')"
                          />
                          <div class="error--text caption" v-if="errors.has(`parcel.height`)">
                            {{ errors.first(`parcel.height`) }}
                          </div>
                        </v-flex>
                        <v-flex class="form-control pl-1">
                          <input
                            v-validate="'required'"
                            :name="`parcel.weight`"
                            type="text"
                            v-model="tmporders[oindex][index].parcel.weight"
                            :placeholder="$t('weight')"
                            :data-vv-as="$t('weight')"
                          />
                          <div class="error--text caption" v-if="errors.has(`parcel.weight`)">
                            {{ errors.first(`parcel.weight`) }}
                          </div>
                          <div class="caption grey--text">น้ำหนักสูงสุด 25kg</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider
                    :key="'shippop_divider_' + oindex + '_' + order.orderid"
                    v-if="oindex != tmporders.length - 1 || index != orders.length - 1"
                  ></v-divider>
                </template>
              </template>
            </div>

            <v-divider />
            <div class="text-xs-center">
              <v-btn color="grey" outline :loading="loading" @click="step = 1">{{
                $t('Back')
              }}</v-btn>
              <v-btn color="primary" depressed @click="confirmShippop" :loading="loading">{{
                $t('Next')
              }}</v-btn>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <preview-shippop-cover
      v-if="showPreview"
      v-model="showPreview"
      :purchase_id="currentPaymentID"
      @closePreview="closePreview"
    ></preview-shippop-cover>
    <v-dialog style="z-index: 210" v-model="loadingTmporders" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          กรุณารอสักครู่
          <v-progress-linear
            color="#FFFFFF"
            style="border-radius: 5px;"
            class="text-xs-center"
            v-model="loadingTmpordersValue"
            height="19"
          >
            <strong style="font-size: 14px; color: #FFF;">{{ loadingTmpordersValue }}%</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPayment" max-width="1000" hide-overlay scrollable persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="closePayment">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text style="max-height: 800px">
          <h2 class="text-xs-center">ส่งข้อมูลไปที่ shippop สำเร็จ</h2>

          <template v-if="showPayment">
            <template v-for="order in shippop_paymentids">
              <div :key="order">
                <v-layout>
                  <v-flex class="pa-3">หมายเลขการชำระเงินคือ {{ order }}</v-flex>
                  <v-flex shrink
                    ><v-btn
                      @click="
                        currentPaymentID = order
                        showPreview = true
                      "
                      color="primary"
                      >ปริ้นใบปะหน้า</v-btn
                    ></v-flex
                  >
                </v-layout>
                <v-divider />
              </div>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectShippopCourier from './SelectShippopCourier'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'
import api from '@/api'
import PreviewShippopCover from './PreviewShippopCover.vue'
import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'

/*
Step1 -> checkorderlist

Step2 -> confirmShippop
*/

export default {
  props: ['value', 'orders'],
  components: {
    SelectShippopCourier,
    ShippingAddress,
    PreviewShippopCover
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      addresses: 'getShippingAddress'
    }),
    totalOrder() {
      return this.tmporders.reduce((prev, curr) => {
        prev = prev + curr.length
        return prev
      }, 0)
    }
  },
  data() {
    return {
      loadingTmporders: false,
      loadingTmpordersValue: 0,
      step: 1,
      loading: true,
      useCustomCourier: 'bycustomer',
      customCourier: null,
      couriers: [
        {
          text: 'ไปรษณีย์ไทย EMS',
          value: 'THP'
        },
        {
          text: 'ไปรษณีย์ไทย (Eco-post)',
          value: 'ECP'
        },
        {
          text: 'ไปรษณีย์ไทย (EMS Special)',
          value: 'EMST'
        },
        {
          text: 'Kerry Express',
          value: 'KRY'
        },
        {
          text: 'Kerry Pickup',
          value: 'KRYP'
        },
        {
          text: 'Kerry Dropoff',
          value: 'KRYD'
        },
        {
          text: 'Kerry Exclusive',
          value: 'KRYX'
        },
        {
          text: 'Rush Bike',
          value: 'RSB'
        },
        {
          text: 'Skootar',
          value: 'SKT'
        },
        {
          text: 'SCG Yamato Express',
          value: 'SCG'
        },
        {
          text: 'SCG Yamato Express Chilled',
          value: 'SCGC'
        },
        {
          text: 'SCG Yamato Express Frozen',
          value: 'SCGF'
        },
        {
          text: 'SCG Express Exclusive',
          value: 'SCGX'
        },
        {
          text: 'Lalamove',
          value: 'LLM'
        },
        {
          text: 'Ninjavan',
          value: 'NJV'
        },
        {
          text: 'Flash Express',
          value: 'FLE'
        },
        {
          text: 'Flash Speed',
          value: 'FLES'
        },
        {
          text: 'Best Express',
          value: 'BEST'
        },
        {
          text: 'JWD Express Chilled',
          value: 'JWDC'
        },
        {
          text: 'JWD Express Frozen',
          value: 'JWDF'
        },
        {
          text: 'Aramex',
          value: 'ARM'
        },
        {
          text: 'Shopee Xpress',
          value: 'SPX'
        },
        {
          text: 'Popman',
          value: 'POM'
        },
        { text: 'SPRESS (Pickup)', value: 'EMSXP' },
        { text: 'Makesend', value: 'MSE' },
        { text: 'Makesend Cool', value: 'MSEC' },
        { text: 'DHL Express', value: 'DHL' }
      ],
      tmporders: [],
      shopaddress: null,
      showPayment: false,
      showPreview: false,
      currentPaymentID: null,
      shippop_paymentids: []
    }
  },
  async mounted() {
    this.loading = false
  },
  methods: {
    closePayment() {
      this.showPayment = false
      location.reload()
    },
    closePreview() {
      this.showPreview = false
      // location.reload()
    },
    async checkorderlist() {
      try {
        this.tmporders = []
        var options = {}

        if (this.useCustomCourier == 'bymerchant' && this.customCourier) {
          options.setallcourier = this.customCourier
        }
        var selectedAddress = this.addresses.find(el => {
          return el.selected
        })
        if (selectedAddress) {
          options.shopaddress = selectedAddress
          let partition_size = 100
          let orders = cloneDeep(this.orders)
          let splited_orders = [],
            orderlistPromise = [],
            count = Math.ceil(orders.length / partition_size)

          for (let i = 0; i < count; i++) {
            if (count == i) {
              splited_orders.push(orders)
            } else {
              let t = orders.splice(0, partition_size)
              splited_orders.push(t)
            }
          }

          splited_orders.forEach(order => {
            orderlistPromise.push(this.shippopcheckorderlist(order, options))
          })

          let orderlistResponse = await Promise.all(orderlistPromise.map(e => e.catch(e => e)))
          const invalidResults = orderlistResponse
            .filter(result => result instanceof Error || result.responsecode != 200)
            .map(e => e)
          if (invalidResults[0] && invalidResults[0].message) {
            this.$emit('getOrderErrorShippop', invalidResults[0].message.split(':')[1])
          }
          const result = await this.alertError(invalidResults)
          if (result) {
            const validResults = orderlistResponse.filter(
              result => !(result instanceof Error) && result.responsecode == 200
            )

            let countTmporders = 0
            if (validResults && validResults.length > 0) {
              this.loadingTmporders = true
              validResults.forEach(response => {
                if (response.responsecode == 200 && response.data) {
                  const order = response.data.map(el => {
                    return { ...el, courier_code: null }
                  })
                  setTimeout(() => {
                    this.tmporders.push(order)
                    countTmporders += this.tmporders[this.tmporders.length - 1].length
                    this.loadingTmpordersValue = parseInt(
                      (countTmporders / this.orders.length) * 100
                    )
                    if (countTmporders === this.orders.length) {
                      this.loadingTmporders = false
                    }
                  }, 1000)
                }
              })

              return true
            } else {
              return false
            }
          }
        } else {
          throw new Error('ที่อยู่ไม่ถูกต้อง')
        }
      } catch (error) {
        await this.$swal({
          title: this.$t('Error'),
          type: 'error',
          text: error.message,
          confirmButtonText: this.$t('Confirm')
        })
        return false
      }
    },
    async shippopcheckorderlist(list, options) {
      var vm = this
      var orderidlist = list.map(el => el.id)
      return new Promise((resolve, reject) => {
        api.shippopcheckorderlist(
          {
            params: { pageid: vm.selectedBot.pageid },
            body: {
              orderidlist: orderidlist.join(','),
              ...options
            }
          },
          async (error, response) => {
            if (response.data) {
              let notFoundShipping = []
              let foundShipping = []

              response.data.map(order => {
                if (JSON.stringify(order.shippopresult) === '[]') {
                  notFoundShipping.push(order)
                } else {
                  foundShipping.push(order)
                }
              })

              notFoundShipping = notFoundShipping.sort((a, b) => {
                return JSON.stringify(a.shippopresult).localeCompare(
                  JSON.stringify(b.shippopresult)
                )
              })

              foundShipping.sort((a, b) => {
                return a.orderid - b.orderid
              })

              response.data = notFoundShipping.concat(foundShipping)
            }
            //console.log(error)
            if (error) {
              if (
                error.message == 'Please insert pageaddress AND companyname AND Tel.' ||
                error.message ==
                  'Please insert zipcode in pageaddress or companyname,companyphoneno is empty'
              ) {
                var error_message = ''
                if (error.message == 'Please insert pageaddress AND companyname AND Tel.')
                  error_message = 'กรุณาใส่ชื่อ, ที่อยู่ และเบอร์โทรของผู้จัดส่ง (แก้ไขร้านค้า)'
                else if (
                  error.message ==
                  'Please insert zipcode in pageaddress or companyname,companyphoneno is empty'
                )
                  error_message =
                    'กรุณาตรวจสอบรหัสไปรษณีย์ของผู้จัดส่ง หรือ ชื่อและเบอร์โทรของผู้จัดส่งอีกครั้ง (แก้ไขร้านค้า)'

                var result = await vm.$swal({
                  title: error_message,
                  type: 'error',
                  showCancelButton: true,
                  confirmButtonText: vm.$t('ตั้งค่าร้านค้า'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
                if (result.value) {
                  vm.$emit('isEditShop', true)
                }
              } else {
                // error_message = error.message
                // var result = await vm.$swal({
                //   title: error_message,
                //   type: 'error',
                //   cancelButtonText: vm.$t('cancel'),
                //   reverseButtons: true
                // })
              }

              reject(error)
            }
            resolve(response)
          }
        )
      })
    },
    close() {
      this.step = 1
      this.customCourier = null
      this.useCustomCourier = 'bycustomer'
      this.$emit('input', false)
    },
    async nextStep(step) {
      var result = await this.$validator.validateAll()

      if (!result) {
        this.goToErrorInput()
        return false
      }
      if (step == 2) {
        // console.log('check')
        this.loading = true
        let result = await this.checkorderlist()
        // if (result) {
        this.step = step
        // }
        this.loading = false
      } else {
        this.step = step
      }
    },
    async confirmShippop() {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        await this.$swal({
          title: 'ข้อมูลไม่ครบถ้วนหรือไม่สามารถจัดส่งบางออเดอร์ได้',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
        return false
      }

      this.loading = true

      let packages = cloneDeep(this.tmporders)
      packages = packages.map(orders => {
        return orders.map(el => {
          let order = el
          delete order.shippopresult
          if (order.orderzwiz.shippingtype == 'cod_charge') {
            order.cod_amount = order.orderzwiz.amount
          }
          return { ...order }
        })
      })
      let packagesPromise = []
      let a = Math.floor(Math.random() * 10000) - 1 // 0-9999
      var group_id = a.toString().padStart(5, '0') + dayjs().format('x')
      packages.forEach(orders => {
        packagesPromise.push(this.shippopbookingandconfirm(group_id, orders))
      })

      let packagesResponse = await Promise.all(packagesPromise.map(e => e.catch(e => e)))
      let paymentids = []
      const validResults = packagesResponse.filter(
        result => !(result instanceof Error) && result.responsecode == 200
      )
      const invalidResults = packagesResponse
        .filter(result => result instanceof Error || result.responsecode != 200)
        .map(e => e)
      await this.alertError(invalidResults)

      validResults.forEach(async response => {
        try {
          if (response.responsecode == 200) {
            paymentids.push(response.purchase_id)
            // var result = await this.$swal({
            //   title: 'ส่งข้อมูลไปที่ shippop สำเร็จ',
            //   text: 'หมายเลขการชำระเงินคือ ' + response.purchase_id,
            //   type: 'success',
            //   confirmButtonText: 'ปริ้นใบปะหน้า',
            //   showCancelButton: true,
            //   cancelButtonText: this.$t('cancel'),
            //   reverseButtons: true
            // })
            // this.currentPaymentID = response.purchase_id
            // if (result.value) {
            //   this.showPreview = true
            // } else {
            //   location.reload()
            // }
          } else {
            throw { message: 'shippop confirm unsuccessfully', ...response }
          }
        } catch (error) {
          console.error(error)
          let text = ''
          if (error.response && error.response.shippop_body) {
            if (error.response.shippop_body) {
              let body = error.response.shippop_body.data
              try {
                let parcel = body[Object.keys(body)[0]]
                parcel = parcel[Object.keys(parcel)[0]]
                if (parcel.remark) text = parcel.remark
                if (parcel.err_code) text = text + ` (${parcel.err_code})`
              } catch (error) {
                console.error(error)
              }
            }
          }
          await this.$swal({
            title: 'ส่งข้อมูลไม่สำเร็จ โปรดลองอีกครั้ง',
            text: text,
            type: 'error',
            confirmButtonText: this.$t('Confirm')
          })
        }
      })

      if (paymentids.length > 0) {
        this.shippop_paymentids = paymentids
        this.showPayment = true
      } else {
        this.shippop_paymentids = []
      }
      this.loading = false
    },
    async alertError(invalidResults) {
      if (invalidResults && invalidResults.length > 0) {
        let texts = []

        invalidResults.forEach(el => {
          if (el.response && el.response.shippop_body) {
            for (const [key, value] of Object.entries(el.response.shippop_body.data)) {
              for (const [s_key, s_value] of Object.entries(value)) {
                texts.push(
                  `Order No: ${key} ${s_value.remark || '-'} ${'(' + s_value.err_code + ')' || ''}`
                )
              }
            }
          } else {
            if (el.message) texts.push(el.toString())
          }
        })
        await this.$swal({
          title: this.$t('Error'),
          type: 'error',
          html: texts.join('<br />'),
          confirmButtonText: this.$t('Confirm')
        })
        return false
      }
      return true
    },
    async shippopbookingandconfirm(group_id, order) {
      let options = {
        purchase_group_id: group_id
      }
      var responseBooking = await this.shippopbooking(order, options)
      if (responseBooking.responsecode == 200 && responseBooking.status) {
        var responseConfirm = await this.shippopconfirm(responseBooking.purchase_id)
        return responseConfirm
      } else {
        // shippop_body
        throw new Error('shippop booking unsuccessfully')
      }
    },
    async shippopbooking(list, options) {
      var vm = this
      return new Promise((resolve, reject) => {
        api.shippopbooking(
          {
            params: { pageid: vm.selectedBot.pageid },
            body: {
              shippinglist: list,
              ...options
            }
          },
          async (error, response) => {
            if (error) {
              reject({ error, response })
            }
            resolve(response)
          }
        )
      })
    },
    async shippopconfirm(purchase_id) {
      var vm = this
      return new Promise((resolve, reject) => {
        api.shippopconfirm(
          {
            params: { pageid: vm.selectedBot.pageid },
            body: {
              purchase_id: purchase_id
            }
          },
          async (error, response) => {
            if (error) {
              console.error(error)
              reject(error)
            }
            resolve(response)
          }
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippopShipping.vue